package com.qrkontaq.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class MonthAmountDto(
    val month: String,
    val amountMinor: Long,
    val count: Long,
)

@Serializable
data class PlatformOverviewDto(
    val restaurantsTotal: Long = 0,
    val restaurantsActive: Long = 0,
    val usersTotal: Long = 0,
    val ordersTotal: Long = 0,
    val orders30d: Long = 0,
    val guestGmv30dMinor: Long = 0,
    val scans30d: Long = 0,
    val subsFree: Int = 0,
    val subsActive: Int = 0,
    val subsPastDue: Int = 0,
    val autoRenewOn: Int = 0,
    val mrrMinor: Long = 0,
    val revenueTotalMinor: Long = 0,
    val revenue30dMinor: Long = 0,
    val paymentsCount: Int = 0,
    val currency: String = "EUR",
    val revenueByMonth: List<MonthAmountDto> = emptyList(),
    val newRestaurantsByDay: List<DayCountDto> = emptyList(),
    val newUsersByDay: List<DayCountDto> = emptyList(),
)

@Serializable
data class PlatformRestaurantDto(
    val id: String,
    val name: String,
    val slug: String,
    val status: String = "ACTIVE",
    val currency: String = "EUR",
    val createdAt: String = "",
    val ownerId: String? = null,
    val ownerEmail: String? = null,
    val ownerName: String? = null,
    val plan: String? = null,
    val subscriptionStatus: String? = null,
    val paidUntil: String? = null,
    val autoRenew: Boolean = false,
    val ordersTotal: Long = 0,
    val orders30d: Long = 0,
    val revenue30dMinor: Long = 0,
    val lastOrderAt: String? = null,
)

@Serializable
data class WebDayStatDto(
    val date: String,
    val visitors: Long = 0,
    val sessions: Long = 0,
    val pageviews: Long = 0,
)

@Serializable
data class WebNameCountDto(
    val name: String,
    val count: Long = 0,
)

@Serializable
data class WebPageStatDto(
    val path: String,
    val views: Long = 0,
    val visitors: Long = 0,
)

@Serializable
data class WebAnalyticsDto(
    val uniqueVisitors: Long = 0,
    val sessions: Long = 0,
    val pageviews: Long = 0,
    val clicks: Long = 0,
    val newVisitors: Long = 0,
    val activeNow: Long = 0,
    val avgSessionSeconds: Long = 0,
    val byDay: List<WebDayStatDto> = emptyList(),
    val topPages: List<WebPageStatDto> = emptyList(),
    val topClicks: List<WebNameCountDto> = emptyList(),
    val sections: List<WebNameCountDto> = emptyList(),
    val langSwitches: List<WebNameCountDto> = emptyList(),
    val referrers: List<WebNameCountDto> = emptyList(),
    val utmSources: List<WebNameCountDto> = emptyList(),
    val devices: List<WebNameCountDto> = emptyList(),
    val browsers: List<WebNameCountDto> = emptyList(),
    val languages: List<WebNameCountDto> = emptyList(),
    val countries: List<WebNameCountDto> = emptyList(),
    val cities: List<WebNameCountDto> = emptyList(),
    val funnel: WebFunnelDto = WebFunnelDto(),
)

@Serializable
data class WebFunnelDto(
    val landingSessions: Long = 0,
    val pricingReached: Long = 0,
    val ctaClicked: Long = 0,
    val adminReached: Long = 0,
    val signups: Long = 0,
)

@Serializable
data class WebSessionStepDto(
    val type: String,
    val label: String,
    val at: String = "",
)

@Serializable
data class WebSessionDto(
    val sessionId: String,
    val startedAt: String = "",
    val durationSeconds: Long = 0,
    val site: String = "",
    val country: String? = null,
    val city: String? = null,
    val device: String? = null,
    val browser: String? = null,
    val os: String? = null,
    val referrer: String? = null,
    val utmSource: String? = null,
    val isNew: Boolean = false,
    val isActive: Boolean = false,
    val steps: List<WebSessionStepDto> = emptyList(),
)

@Serializable
data class PlatformPaymentDto(
    val id: String,
    val restaurantId: String,
    val restaurantName: String,
    val plan: String,
    val amountMinor: Long,
    val currency: String,
    val status: String,
    val recurring: Boolean = false,
    val createdAt: String = "",
    val paidAt: String? = null,
)
